import { ShopifyApi } from '../api/ShopifyApi'
import type { ShopifyCompletionCommand, ShopifyCompletionDto } from '../models/callback.types'

import { ApiError } from '@/shared/http'

export class ShopifyCallbackService {
  constructor(private readonly api = new ShopifyApi()) {}

  async complete(command: ShopifyCompletionCommand): Promise<ShopifyCompletionDto> {
    return decodeShopifyCompletion(await this.api.complete(command))
  }
}

export function decodeShopifyCompletion(value: unknown): ShopifyCompletionDto {
  if (!value || typeof value !== 'object') throw malformed(value)
  const dto = value as Partial<ShopifyCompletionDto>
  const validId = (candidate: unknown): candidate is number | string =>
    (typeof candidate === 'number' && Number.isFinite(candidate)) ||
    (typeof candidate === 'string' && candidate.trim() !== '')

  if (
    !validId(dto.workspace_id) ||
    !validId(dto.account) ||
    !validId(dto.store_id) ||
    typeof dto.already_installed !== 'boolean'
  ) {
    throw malformed(value)
  }
  return dto as ShopifyCompletionDto
}

function malformed(payload: unknown): ApiError {
  return new ApiError({
    kind: 'unknown',
    status: null,
    code: 'SHOPIFY_COMPLETION_MALFORMED',
    fields: {},
    payload,
    userVisible: true,
    detail: 'Malformed Shopify completion response',
  })
}
